module.exports = __webpack_public_path__ + "img/dad_02.e0142a34.svg";